(() => {
    const bbbioForm = document.getElementById("bbbio-dna-isolation-form");
    const bbbioSamplesContainer = document.getElementById("bbbio-samples");
    const bbbioTemplate = document.getElementById("bbbio-sample-template");
    const bbbioStatus = document.getElementById("bbbio-status");
    const bbbioAuthorizationDate = document.getElementById("bbbio-authorization-date");
    const bbbioContactName = document.querySelector("[data-bbbio-dna-contact-name]");
    const bbbioContactEmail = document.querySelector("[data-bbbio-dna-contact-email]");
    const bbbioContactPhone = document.querySelector("[data-bbbio-dna-contact-phone]");
    const bbbioContactBody = document.querySelector("[data-bbbio-dna-contact-body]");

    if (!bbbioForm || !bbbioSamplesContainer || !bbbioTemplate || !bbbioStatus || !bbbioContactName || !bbbioContactEmail || !bbbioContactPhone || !bbbioContactBody) return;

    const bbbioServiceNames = {
      genomic: "Genomic DNA isolation",
      hmw: "High-molecular-weight DNA isolation",
      cfdna: "cfDNA isolation",
      microbial: "Microbial DNA isolation",
      plasmid: "Plasmid DNA isolation",
      ffpe: "FFPE DNA isolation",
      cleanup: "DNA cleanup or concentration",
      qc: "DNA QC only"
    };

    function bbbioShowStatus(message) {
      bbbioStatus.textContent = message;
      bbbioStatus.dataset.bbbioVisible = "true";
    }

    function bbbioClearStatus() {
      bbbioStatus.textContent = "";
      bbbioStatus.dataset.bbbioVisible = "false";
    }

    function bbbioSetConditional(group, visible) {
      group.hidden = !visible;
      group.querySelectorAll("input, select, textarea").forEach((control) => {
        control.disabled = !visible;
      });
    }

    function bbbioAssignDynamicLabels(card, sampleNumber) {
      card.querySelectorAll("[data-field]").forEach((control) => {
        const fieldKey = control.dataset.field;
        const slug = fieldKey.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        const controlId = `bbbio-sample-${sampleNumber}-${slug}`;
        control.id = controlId;
        control.name = `sample_${sampleNumber}_${fieldKey}`;

        const wrapper = control.closest(".bbbio-form-field");
        if (wrapper) {
          const label = wrapper.querySelector("label:not(.bbbio-choice)");
          if (label) label.htmlFor = controlId;
        }
      });

      card.querySelectorAll("[data-service]").forEach((control) => {
        const key = control.dataset.service;
        control.id = `bbbio-sample-${sampleNumber}-service-${key}`;
        control.name = `sample_${sampleNumber}_services`;
        control.value = key;
      });
    }

    function bbbioRenumberSamples() {
      const cards = Array.from(bbbioSamplesContainer.querySelectorAll(".bbbio-sample-card"));
      cards.forEach((card, index) => {
        const sampleNumber = index + 1;
        card.dataset.bbbioSampleIndex = String(sampleNumber);
        const number = card.querySelector(".bbbio-sample-number");
        if (number) number.textContent = String(sampleNumber);
        bbbioAssignDynamicLabels(card, sampleNumber);
      });

      const count = document.getElementById("bbbio-sample-count");
      if (count) count.value = String(cards.length);
    }

    function bbbioUpdateSampleWarning(card) {
      const material = card.querySelector(".bbbio-sample-material").value;
      const cfdna = card.querySelector("[data-service='cfdna']").checked;
      const hmw = card.querySelector("[data-service='hmw']").checked;
      const plasmid = card.querySelector("[data-service='plasmid']").checked;
      const warning = card.querySelector(".bbbio-sample-warning");

      let message = "";
      if (cfdna && material && !["Plasma", "Serum"].includes(material)) {
        message = "cfDNA isolation is normally performed from qualified plasma or serum. Confirm compatibility with the technical team.";
      } else if (hmw && material === "FFPE tissue") {
        message = "FFPE fixation is generally incompatible with high-molecular-weight DNA recovery. Select FFPE DNA isolation or request technical review.";
      } else if (plasmid && material && material !== "Plasmid-containing bacterial culture") {
        message = "Plasmid DNA isolation normally requires a plasmid-containing bacterial culture. Confirm the material or selected service.";
      }

      warning.textContent = message;
      warning.dataset.bbbioVisible = message ? "true" : "false";
    }

    function bbbioUpdateMaterialFields(card) {
      const material = card.querySelector(".bbbio-sample-material").value;
      const states = [
        [".bbbio-ffpe-fields", material === "FFPE tissue"],
        [".bbbio-tissue-cell-fields", [
          "Fresh or frozen tissue",
          "Plant tissue or seed",
          "Cells or cell pellet",
          "Bacterial culture or pellet",
          "Fungal culture or material",
          "Plasmid-containing bacterial culture"
        ].includes(material)],
        [".bbbio-blood-fields", material === "Whole blood" || material === "Bone marrow"],
        [".bbbio-plasma-serum-fields", material === "Plasma" || material === "Serum"],
        [".bbbio-swab-saliva-fields", material === "Saliva or buccal sample" || material === "Swab"],
        [".bbbio-complex-matrix-fields", ["Stool", "Urine or other body fluid", "Environmental sample", "Other"].includes(material)]
      ];

      states.forEach(([selector, visible]) => {
        const group = card.querySelector(selector);
        if (group) bbbioSetConditional(group, visible);
      });

      bbbioUpdateSampleWarning(card);
    }

    function bbbioAddSample() {
      const fragment = bbbioTemplate.content.cloneNode(true);
      const card = fragment.querySelector(".bbbio-sample-card");

      card.querySelector(".bbbio-remove-sample").addEventListener("click", () => {
        if (bbbioSamplesContainer.querySelectorAll(".bbbio-sample-card").length > 1) {
          card.remove();
          bbbioRenumberSamples();
        }
      });

      card.querySelector(".bbbio-sample-material").addEventListener("change", () => {
        bbbioUpdateMaterialFields(card);
      });

      card.querySelectorAll("[data-service]").forEach((box) => {
        box.addEventListener("change", () => bbbioUpdateSampleWarning(card));
      });

      bbbioSamplesContainer.appendChild(fragment);
      bbbioRenumberSamples();
      bbbioUpdateMaterialFields(card);
    }

    function bbbioAddValue(target, key, value) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        target[key] = Array.isArray(target[key]) ? target[key].concat(value) : [target[key], value];
      } else {
        target[key] = value;
      }
    }

    function bbbioCollectData() {
      const data = {};
      const samples = [];

      new FormData(bbbioForm).forEach((value, key) => {
        const isSystemField = key.startsWith("contact[")
          || ["form_type", "utf8", "h-captcha-response", "g-recaptcha-response"].includes(key);
        if (!key.startsWith("sample_") && !key.startsWith("attest") && !isSystemField) {
          bbbioAddValue(data, key, value);
        }
      });

      bbbioSamplesContainer.querySelectorAll(".bbbio-sample-card").forEach((card) => {
        const sample = {};
        card.querySelectorAll("[data-field]:not(:disabled)").forEach((control) => {
          if (control.value !== "") sample[control.dataset.field] = control.value;
        });
        sample.services = Array.from(card.querySelectorAll("[data-service]:checked")).map((control) => {
          return bbbioServiceNames[control.dataset.service];
        });
        samples.push(sample);
      });

      data.samples = samples;
      data.customerAttestations = {
        accurate: document.getElementById("bbbio-attest-accurate").checked,
        noDirectIdentifiers: document.getElementById("bbbio-attest-identifiers").checked,
        hazardsDisclosed: document.getElementById("bbbio-attest-hazards").checked
      };
      data.generatedAt = new Date().toISOString();
      return data;
    }

    function bbbioValidateSelections() {
      if (!bbbioForm.querySelector("input[name='requestedServices']:checked")) {
        return "Select at least one DNA isolation or QC service.";
      }

      const missing = Array.from(
        bbbioSamplesContainer.querySelectorAll(".bbbio-sample-card")
      ).some((card) => !card.querySelector("[data-service]:checked"));

      return missing ? "Select at least one DNA service for every sample." : "";
    }

    document.getElementById("bbbio-add-sample").addEventListener("click", bbbioAddSample);
    document.getElementById("bbbio-print-form").addEventListener("click", () => window.print());

    bbbioForm.addEventListener("submit", (event) => {
      bbbioClearStatus();

      if (!bbbioForm.checkValidity()) {
        event.preventDefault();
        bbbioForm.reportValidity();
        bbbioShowStatus("Complete all required fields before submitting the request.");
        return;
      }

      const selectionError = bbbioValidateSelections();
      if (selectionError) {
        event.preventDefault();
        bbbioShowStatus(selectionError);
        return;
      }

      bbbioContactName.value = bbbioForm.elements.contactName.value;
      bbbioContactEmail.value = bbbioForm.elements.email.value;
      bbbioContactPhone.value = bbbioForm.elements.phone.value;
      bbbioContactBody.value = `DNA ISOLATION SERVICE REQUEST\n\n${JSON.stringify(bbbioCollectData(), null, 2)}`;
      bbbioShowStatus("Submitting your request securely…");
    });

    document.getElementById("bbbio-download-json").addEventListener("click", () => {
      bbbioClearStatus();

      if (!bbbioForm.checkValidity()) {
        bbbioForm.reportValidity();
        bbbioShowStatus("Complete all required fields before exporting the request.");
        return;
      }

      const selectionError = bbbioValidateSelections();
      if (selectionError) {
        bbbioShowStatus(selectionError);
        return;
      }

      const blob = new Blob([JSON.stringify(bbbioCollectData(), null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "bnb-bio-dna-isolation-service-request.json";
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
      bbbioShowStatus("Request JSON created locally. No submission was transmitted.");
    });

    bbbioForm.addEventListener("reset", () => {
      setTimeout(() => {
        bbbioSamplesContainer.innerHTML = "";
        bbbioAddSample();
        bbbioClearStatus();
        if (bbbioAuthorizationDate) bbbioAuthorizationDate.valueAsDate = new Date();
      }, 0);
    });

    if (bbbioAuthorizationDate) bbbioAuthorizationDate.valueAsDate = new Date();
    bbbioAddSample();
  })();
